export default "//static.tradera.net/touchweb/static/output/images/category-computers-accessories.5cdf89e0.svg";